import React, { useState, useEffect } from "react";
import { FnAxios, FnDialog, I18n, SecureStorage, Unauthorize } from 'utilities/utilities';
import Countdown from 'react-countdown';
import Dialog from "@mui/material/Dialog";
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle, useMediaQuery, useTheme } from "@mui/material";
import ConfirmBtnIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/ErrorOutline";
import { APIStatusCode, I18NextNs } from "enum/enum";
import { ApiAuthentication } from 'enum/api';
import jwt_decode from "jwt-decode";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import { useLocation } from "react-router";
import { GetUserAccout } from "utilities/SystemFunction";
import axios from "axios";
import { HubConnectionBuilder, HubConnectionState } from "@microsoft/signalr";

// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router";
// import { HubConnectionBuilder, HubConnectionState } from '@microsoft/signalr';
// import DialogActionCreators from "store/redux/DialogAlert";
// import { GetUserAccout } from "utilities/SystemFunction";

const AuthSession = () => {
    const location = useLocation();
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const theme = useTheme();
    const IsFullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const [IsOpen, setIsOpen] = useState(false)
    const [nMinuteConfig] = useState(3)
    const [nMinuteCountDown, setnMinuteCountDown] = useState(3)

    useEffect(() => {
        const IsPassPopup = secureLocalStorage.getItem("IsPassPopup") as string;
        if(IsPassPopup !== "1")
        {
            secureLocalStorage.setItem("IsPassPopup", "0");
        }
    }, [])
    
    useEffect(() => {
        const IntervalCheckToken = setInterval(() => {
            const envJWT = process.env.REACT_APP_JWT_KEY
            const authToken = secureLocalStorage.getItem(envJWT) as string;
            const IsPassPopup = secureLocalStorage.getItem("IsPassPopup") as string;
            if (authToken) {
                const decoded = jwt_decode(authToken);
                const expUser = decoded["exp"];
                const minuteExpire = ((moment.unix(expUser)).diff(moment().valueOf(), 'second')) / 60;
                
                if (nMinuteConfig >= minuteExpire && IsPassPopup === "0") {
                    const checkMinMinute = minuteExpire > nMinuteConfig ? nMinuteConfig : minuteExpire;
                    const dateCountdown = Date.now() + (60000 * checkMinMinute)
                    setnMinuteCountDown(dateCountdown)
                    setIsOpen(true)
                    secureLocalStorage.setItem("IsPassPopup", "1");
                }
                else if (minuteExpire <= 0 && IsPassPopup === "1") {
                    // setIsOpen(false)
                    // Unauthorize(DialogFn);

                    setIsOpen(true);
                }
            }
        }, 1000);
        return () => clearInterval(IntervalCheckToken)

    }, [DialogFn, nMinuteConfig]);

    useEffect(() => {
        const authToken = secureLocalStorage.getItem(process.env.REACT_APP_JWT_KEY) as string;
        if (authToken) {
            const decoded = jwt_decode(authToken);
            const expUser = decoded["exp"];
            const minuteExpire = ((moment.unix(expUser)).diff(moment().valueOf(), 'second')) / 60;
            const checkMinMinute = minuteExpire > nMinuteConfig ? nMinuteConfig : minuteExpire;
            const dateCountdown = Date.now() + (60000 * checkMinMinute)
            setnMinuteCountDown(dateCountdown)
        }
    }, [location, nMinuteConfig]);


    const connection = new HubConnectionBuilder()
    .withUrl(process.env.REACT_APP_API_URL + "hubs/auth")
    .withAutomaticReconnect()
    .build();

    const HandleAddSession = () => {
        // let oParam = {
        //     sUsername: "",
        //     sPWD: ""
        // };
        // AxiosFn.Post(ApiAuthentication.Login, oParam, (result) => {
        //     setIsOpen(false)
        //     secureLocalStorage.setItem("IsPassPopup", "0");
        //     const envJWT = process.env.REACT_APP_JWT_KEY
        //     secureLocalStorage.setItem(envJWT, result.objResult)
        // });

        DialogFn.BlockUI();
        let objUser: IAvatar = GetUserAccout();
        let oParam = {
            sUsername: objUser?.sEmail ?? "",
            sPWD: objUser?.sSecuredCode ?? "",
            sIPAddress: objUser?.sIPAddress,
        };
       
        AxiosFn.Post(ApiAuthentication.Login, oParam, (result) => {
            DialogFn.UnBlockUI();
            setIsOpen(false)
            secureLocalStorage.setItem("IsPassPopup", "0");
            let objData = result.objResult;
            if (result.nStatusCode === APIStatusCode.Success)
            {
                if (result.objResult) {
                    SecureStorage.Set(process.env.REACT_APP_JWT_KEY, objData);
                    let objUser: IAvatar = GetUserAccout();
                    let sConnectionId = objUser.nUserID;
                    if (connection.state !== HubConnectionState.Connected) {
                        connection
                            .start()
                            .then(() => {
                                connection.send("OnSignOutSignal", sConnectionId ?? connection.connectionId, true)
                                window.location.reload();
                            })
                           
                    } 
                    else {
                        connection.send("OnSignOutSignal", sConnectionId ?? connection.connectionId, false)
                    }
                }
            }
            else {
                DialogFn.Warning(result.sMessage);
            }
        }, null, () => { DialogFn.UnBlockUI(); });
    };

    const HandleCancelAddSession = () => {
        setIsOpen(false);
        secureLocalStorage.setItem("IsPassPopup", "1");
        
        // SecureStorage.Clear();
        SecureStorage.Remove(process.env.REACT_APP_JWT_KEY);
		setTimeout(() => {
			window.location.pathname = `${process.env.PUBLIC_URL}/`;
		}, 500);
    };

    const padLeadingZeros = (num, size) => {
        let s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    };

 
    return (
        <>
            <Dialog
                fullScreen={IsFullScreen}
                open={IsOpen}
                sx={{
                    ".MuiPaper-root": {
                        width: "300px !important",
                        height: "auto",
                        minHeight: "50% !important",
                        borderRadius: "20px !important"
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        height: "40%",
                        backgroundColor: "#ffce3d",
                        color: "#fff",
                        textAlign: "center"
                    }}
                >
                    <WarningIcon
                        style={{
                            fontSize: "10rem",
                            fontWeight: "bold",
                            color: "white",
                        }}
                    />
                </DialogTitle>
                <DialogContent sx={{
                    height: "150% !important",
                    backgroundColor: "#fff",
                    color: "#000",
                    padding: "10px 15px"
                }}
                >
                    <DialogContentText
                        style={{
                            fontSize: "1.5rem",
                            fontWeight: "bold",
                            color: "#000",
                        }}
                    >
                        {I18n.SetText(`Title.SessionExpiring`, I18NextNs.labelComponent)}
                    </DialogContentText>
                    <DialogContentText
                        style={{
                            color: "#000",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                marginTop: '12px',
                                gap: '4px'
                            }}
                        >
                            <span>
                                {I18n.SetText(`Message.SessionExpire`, I18NextNs.labelComponent)}
                            </span>
                            <span>
                                <Countdown
                                    key={"countdown-element"}
                                    date={nMinuteCountDown}
                                    precision={2}
                                    renderer={({ hours, minutes, seconds, completed }) => {
                                        if (completed) {
                                            return <span></span>; //<span>Session Timeout!</span>;
                                        } else {
                                            return <span>{padLeadingZeros(minutes, 2)}:{padLeadingZeros(seconds, 2)}</span>;
                                        }
                                    }}
                                />
                            </span>
                            <span>
                                {I18n.SetText(`Message.SessionConfirm`, I18NextNs.labelComponent)}
                            </span>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    sx={{
                        backgroundColor: "#fff",
                        color: "#000",
                        justifyContent: "center !important",
                        height: "70px"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: '12px'
                        }}
                    >
                        <Button
                            id='btnConfirmSession'
                            variant="contained"
                            style={{
                                background: "#28a745",
                                color: "white",
                                borderRadius: "20px",
                                margin: "8px !important",
                                width: "auto !important",
                                fontSize: "1rem",
                                padding: "4px 15px !important",
                                textTransform: "none"
                            }}
                            size="small"
                            startIcon={
                                <ConfirmBtnIcon
                                    style={{
                                        fontSize: "1.5rem",
                                    }}
                                />
                            }
                            onClick={HandleAddSession}
                        >
                            {I18n.SetText(`Button.Confirm`, I18NextNs.labelComponent)}

                        </Button>
                        <Button
                            id='btnCloseSession'
                            variant="contained"
                            style={{
                                color: "#fff",
                                backgroundColor: "#B6B6B6",
                                borderRadius: "20px",
                                margin: "8px !important",
                                width: "auto !important",
                                fontSize: "1rem",
                                padding: "4px 15px !important",
                                textTransform: "none"
                            }}
                            size="small"
                            startIcon={
                                <CloseIcon
                                    style={{
                                        fontSize: "1.5rem",
                                    }}
                                />
                            }

                            onClick={HandleCancelAddSession}
                        >
                            {I18n.SetText(`Button.Close`, I18NextNs.labelComponent)}
                        </Button>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default AuthSession;